import { FC } from 'react';
import {
  MainPageType,
  useDynamicBreadcrumbLink,
  WbBreadcrumb,
  WbBreadcrumbs,
  WbEnvironmentSelector,
  WbHeader,
  WbHeaderActions,
} from '@agilelab/plugin-wb-platform';
import { useRouteRef } from '@mainstage/core-plugin-api';
import { Box } from '@material-ui/core';
import { useSearchParams } from 'react-router-dom';
import { myProjectsRouteRef } from '../../routes';
import { useReleaseDetailPageContext } from './context/useReleaseDetailPageContext';

export const ReleaseDetailHeader: FC = () => {
  const { release, queryParamVersion, queryParamEnvironment, projectName } =
    useReleaseDetailPageContext();

  const [searchParams, setSearchParams] = useSearchParams();

  const projectsRouteRef = useRouteRef(myProjectsRouteRef);
  const breadcrumbLink = useDynamicBreadcrumbLink(
    projectsRouteRef,
    MainPageType.BUILDER,
  );

  return (
    <WbHeader
      title={
        <Box>
          {projectName} <b>{queryParamVersion || release.metadata.version}</b>
        </Box>
      }
      breadcrumbs={
        <WbBreadcrumbs aria-label="breadcrumb">
          <WbBreadcrumb>Builder</WbBreadcrumb>
          <WbBreadcrumb to={breadcrumbLink}>My Projects</WbBreadcrumb>

          <WbBreadcrumb
            to={`/catalog/${release.metadata.namespace || 'default'}/${
              release.metadata.projectKind ?? 'System'
            }/${
              release.metadata.projectName ?? release.metadata.dataProductName
            }`}
          >
            {projectName}
          </WbBreadcrumb>

          <WbBreadcrumb
            to={`/catalog/${release.metadata.namespace || 'default'}/${
              release.metadata.projectKind ?? 'System'
            }/${
              release.metadata.projectName ?? release.metadata.dataProductName
            }/release`}
          >
            Release
          </WbBreadcrumb>

          <WbBreadcrumb>
            {queryParamVersion || release.metadata.version}
          </WbBreadcrumb>
        </WbBreadcrumbs>
      }
      pageTitleOverride={release.metadata.name}
      topbarActions={
        <WbHeaderActions>
          <WbEnvironmentSelector
            disabled={Boolean(queryParamEnvironment && queryParamVersion)}
            onChange={e => {
              if (searchParams.get('env')) setSearchParams({ env: e });
            }}
          />
        </WbHeaderActions>
      }
    />
  );
};
